/**
 *
 * @param obj
 * @param objModified
 * @returns {boolean}
 */
export default (obj, objModified) => {
  return !Object.entries(objModified).every(([key, value]) => {
    return obj[key] === value;
  });
};



// WEBPACK FOOTER //
// ./src/helpers/objectChanged.js